const middleware: NuxtMiddleware = () => {
  // if (!Object.keys(route.query).length)
  //   return redirect(route.path, { onlyWinners: "true" })
}
export default middleware
